import { Component, Inject, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../shared/services/cms.service';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../shared/services/util.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../shared/services/account.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CustomerService } from '../shared/services/customer.service';
import { catchError, concatMap, EMPTY, type Observable, of } from 'rxjs';
import { CreateCustomerContact } from '../shared/models/create-customer-contact';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../shared/services/error.service';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ActivatedRoute, Router } from '@angular/router';
import { Nav } from '../shared/enums/nav.enum';
import { CTA, SuccessData, SuccessDetails } from '../shared/models/success-data.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../shared/services/storage.service';
import { StorageEnum } from '../shared/enums/storage.enum';

@Component({
  selector: 'app-unauthenticated-paperless',
  imports: [],
  templateUrl: './unauthenticated-paperless.component.html',
  styleUrl: './unauthenticated-paperless.component.scss',
})
export class UnauthenticatedPaperlessComponent {
  pageReady = false;
  pageLabels: any;
  isBrowser = false;
  accountNumber = '';
  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly utils: UtilService,
    private readonly account: AccountService,
    private readonly customer: CustomerService,
    private readonly error: ErrorService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly storage: StorageService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.cms
      .getContent('oas-unauth-paperless', 'Unauthenticated Paperless')
      .pipe(
        concatMap((data) => {
          this.pageLabels = JSON.parse(JSON.stringify(data));
          if (this.isBrowser) {
            return this.setupPaperless();
          } else {
            return EMPTY;
          }
        }),
      )
      .subscribe((data: any) => {
        this.accountNumber = data.AccountId;
        this.setSuccessData();
        void this.router.navigateByUrl(Nav.UnauthenticatedPaperlessSuccess);
      });
  }

  setupPaperless(): Observable<any> {
    // get account number from query param
    const queryParams = this.route.snapshot.queryParams;
    const acctNumberParam = queryParams['accountnumber'];
    const encodedacctNumberParam = decodeURIComponent(acctNumberParam);
    // customer contact request
    const custContact = new CreateCustomerContact();
    custContact.AccountNumber = encodedacctNumberParam;
    custContact.ContactType = 'PAPERSWEMAIL';
    custContact.Comments = ' ,Switch From Paper to Paperless Bill Email Campaign';
    custContact.RequestSource = 'WEB';
    return this.customer.unauthCreateCustomerContact(custContact).pipe(
      catchError((e) => {
        return of('error creating customer contact');
      }),
      concatMap((data: any) => {
        return this.account.unauthPaperlessEnroll(encodedacctNumberParam).pipe(
          catchError((e) => {
            this.setPaperlessErrorData();
            void this.router.navigateByUrl(Nav.UnauthenticatedPaperlessError);
            return EMPTY;
          }),
        );
      }),
    );
  }

  setPaperlessErrorData(): void {
    this.error.setErrorData('none', this.pageLabels.paperlessEnrollErrorData);
  }

  setSuccessData(): void {
    const successLabels = this.pageLabels.unauthPaperlessSuccess.value.data;
    const successData = new SuccessData();
    successData.Header = successLabels.header;
    const acctCTA = successLabels.ctaList.find((cta: any) => {
      return cta.ctaId === 'unauthenticatedPaperlessSuccess';
    });
    const cta = new CTA();
    cta.Label = acctCTA.ctaLabel;
    cta.AriaLabel = acctCTA.ctaAriaLabel;
    cta.Link = acctCTA.ctaUrl;
    successData.CTAList.push(cta);
    successData.Details = [];
    const detail1 = new SuccessDetails();
    detail1.Label = successLabels.details[0].detailLabel;
    detail1.Value = this.accountNumber;
    successData.Details.push(detail1);
    this.storage.setSession(StorageEnum.SuccessData, successData);
  }
}
